import {getAPIDomain} from '../config/constants'
const apiUrl = `${getAPIDomain()}/api/users`;
const authToken = "authToken";
const getAuthHeader = ()=>{
    if(localStorage.getItem(authToken)){
        return "JWT "+localStorage.getItem(authToken);
    }else{
        window.location = "/login";
    }
}
export const updateUser = async (user) =>{
      return fetch(apiUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization":getAuthHeader()
      },
      body:JSON.stringify(user)
    }).then(response => response.json())
  .then(data => (data))
  .catch((error) => {
  console.error('Error:', error);
  })
};

export const getUserById = async (userId) =>{
      return fetch(`${apiUrl}/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization":getAuthHeader()
      }
    }).then(response => response.json())
  .then(data => (data))
  .catch((error) => {
  console.error('Error:', error);
  })
};

export const addUser = async (user) =>{
      return fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization":getAuthHeader()
      },
      body:JSON.stringify(user)
    }).then(response => response.json())
  .then(data => (data))
  .catch((error) => {
  console.error('Error:', error);
  })
};
export const deleteUser = async (rec) =>{
      return fetch(apiUrl, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Authorization":getAuthHeader()
      },
      body:JSON.stringify(rec)
    }).then(response => response.json())
  .then(data => (data))
  .catch((error) => {
  console.error('Error:', error);
  })
};

export const getUsers = async () =>{
  const result =  await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization":getAuthHeader()
      }
    }).then(response => response.json())
  .then(data => (data))
  .catch((error) => {
  console.error('Error:', error);
  })
  if(Array.isArray(result)){
    return result;
  }else if (result.result === "fail"){
    localStorage.clear();
    alert(result.msg);
    window.location = "/";
  }
  return [];
};